export const SEARCH_DEVICES_ENDPOINT = "search/api/v1/search/v1/devices";
export const DEVICE_SOFTWARE_ENDPOINT = "search/api/v1/search/v1/device";
export const DEVICE_SCHEMAS_ENDPOINT = "config/api/v1/devices/schemas";

export const MIN_DEVICE_COUNT = 1;
export const MAX_DEVICE_COUNT = 50;
